import { atom } from "recoil";

export const USER_DEFAULTS = {
  fullName: "",
  mobileNumber: "",
  email: "",
};

const loadUserFromSession = () => {
  try {
    const fullName =
      sessionStorage.getItem("fullName") || "";

    const mobileNumber =
      sessionStorage.getItem("mobileNumber") || "";

    const email =
      sessionStorage.getItem("email") || "";

    return {
      fullName,
      mobileNumber,
      email,
    };
  } catch {
    return USER_DEFAULTS;
  }
};

export const userState = atom({
  key: "userState",

  default: loadUserFromSession(),

  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        if (
          newValue?.fullName &&
          newValue?.mobileNumber
        ) {
          sessionStorage.setItem(
            "fullName",
            newValue.fullName
          );

          sessionStorage.setItem(
            "mobileNumber",
            newValue.mobileNumber
          );

          if (newValue.email) {
            sessionStorage.setItem(
              "email",
              newValue.email
            );
          } else {
            sessionStorage.removeItem("email");
          }
        } else {
          /*
           * This runs when logout sets:
           * setUser(USER_DEFAULTS)
           */
          sessionStorage.removeItem("fullName");
          sessionStorage.removeItem("mobileNumber");
          sessionStorage.removeItem("email");
          sessionStorage.removeItem("authToken");
          sessionStorage.removeItem("tableId");
          sessionStorage.removeItem("qrContext");
        }
      });
    },
  ],
});